import React, { useRef, useState } from 'react';

import { useDataContext } from 'src/context/data';

import { useEventListenerOnce, useWindowInnerHeightAndWidthIfResize } from 'src/utils/hooks';

import Header from './Header/Header';
import Testimonials from './Testimonials/Testimonials';
import Message from './Message/Message';
import Responses from './Responses/Responses';
import StyledModal from './StyledModal/StyledModal';

import dimensionsModule from 'src/utils/styles/_dimensions.module.scss';

/* - - - - - - - - - - - - - - - - - - - - - */

const dimensions = dimensionsModule.locals;
const DEFAULT_WIDGET_WIDTH = 380;

/* - - - - - - - - - - - - - - - - - - - - - */

function Conversation() {
  const {
    appState: {
      widgetData: { config, parameters },
    },
    registerFirstClick,
  } = useDataContext();

  const { windowInnerHeight, windowInnerWidth } = useWindowInnerHeightAndWidthIfResize();

  const [isResponsesAnimationComplete, setResponsesAnimationComplete] = useState<boolean>(false);

  const containerRef = useRef<HTMLDivElement>(null);

  useEventListenerOnce('click', registerFirstClick, containerRef, true);

  const widgetWidth = parameters.chatbotWidth ? parameters.chatbotWidth : DEFAULT_WIDGET_WIDTH;

  return (
    <div
      className={`rcw-conversation-container`}
      ref={containerRef}
      style={
        windowInnerWidth < dimensions.mobileBreakpoint
          ? { minHeight: windowInnerHeight + 'px', width: '100vw' }
          : { minHeight: 'auto', width: widgetWidth + 'px' }
      }
      data-cy="conversation-container"
    >
      <div className="rcw-conversation-inner-container" aria-live="polite">
        <Header />
        {parameters.isTestimonialsAndCredibilityBuildersBarEnabled && (
          <Testimonials dialogConfig={config} parameters={parameters} />
        )}

        <div
          className={`rcw-message-responses-wrapper  ${
            parameters.isTestimonialsAndCredibilityBuildersBarEnabled ? 'testimonials_enabled' : ''
          }`}
        >
          <Message isMessageAreaCanGetComponentHeightParameters={isResponsesAnimationComplete} />
          <Responses onResponsesAnimationComplete={setResponsesAnimationComplete} />
        </div>
      </div>
      <StyledModal />
    </div>
  );
}

export default Conversation;
